// Navbar.jsx completo con separación desktop/mobile
import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, doc, updateDoc, onSnapshot } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser, faMoneyBill, faWallet, faCalendarAlt, faComments, faSignOutAlt,
    faSitemap, faUserGroup
} from '@fortawesome/free-solid-svg-icons';
import { Menu, X } from 'lucide-react';
import logoClaro from '../img/logoDark.png';
import logo from '../images/Logo.png';
import './NavBarAirbnbStyle.css';
import coworkingB from '../img/coworkingB.png';
import serviciosB from '../img/servicioB.png';
import academiaB from '../img/academiaB.png';
import coworkingN from '../img/coworkingN.png';
import serviciosN from '../img/servicioN.png';
import academiaN from '../img/academiaN.png';
import { onAuthStateChanged } from 'firebase/auth';
const avatarsMap = {
    userAvatar1: require('../images/1.png'),
    userAvatar2: require('../images/2.png'),
    userAvatar3: require('../images/3.png'),
    userAvatar4: require('../images/4.png'),
    userAvatar5: require('../images/5.png'),
    userAvatar6: require('../images/6.png'),
    userAvatar7: require('../images/7.png'),
    userAvatar8: require('../images/8.png'),
};

const db = getFirestore(appFirebase);
const auth = getAuth();

function Navbar({ isDarkMode, toggleDarkMode }) {
    const [avatarName, setAvatarName] = useState('userAvatar1');
    const [usuario, setUsuario] = useState(null);
    const [userName, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();
    const userMenuRef = useRef(null);
    const [uid, setUid] = useState(null);
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, user => {
            if (user) setUid(user.uid);
        });
        return unsub;
    }, []);
    const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || avatarsMap.userAvatar1;
    const handleMenuLinkClick = () => {
        setMenuOpen(false);
    };
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user);
                const userDocRef = doc(db, 'usuarios', user.uid);
                return onSnapshot(userDocRef, (doc) => {
                    if (doc.exists()) {
                        const data = doc.data();
                        setRole(data.role);
                        setUserName(data.name || '');
                        setAvatarName(data.avatar || 'userAvatar1');
                    }
                });
            } else {
                setUsuario(null);
                setRole('');
                setUserName('');
                setAvatarName('userAvatar1');
            }
        });
        return () => unsubscribe();
    }, []);
    const [scrollDirection, setScrollDirection] = useState(null);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScrollDirection = () => {
            if (window.scrollY > lastScrollY) {
                setScrollDirection('down');
            } else {
                setScrollDirection('up');
            }
            lastScrollY = window.scrollY;
        };
        window.addEventListener('scroll', handleScrollDirection);
        return () => window.removeEventListener('scroll', handleScrollDirection);
    }, []);

    const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);
    const handleSignOut = () => { signOut(auth); setUserMenuOpen(false); };
    const handleProfileClick = () => { setUserMenuOpen(false); navigate('/myprofile'); };
    const cambiarARolAnfitrion = async () => {
        if (!uid) return;
        try {
            await updateDoc(doc(db, 'usuarios', uid), {
                role: 'prov'
            });
            setRole('prov'); // actualizar estado local si es necesario
            navigate('/crear-perfil-negocio'); // redirigir
        } catch (error) {
            console.error('Error al cambiar de rol:', error);
        }
    };
    return (
        <nav className={`navbar_style_airbnb ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar__container">

                {/* Desktop */}
                <div className="navbar__desktop">
                    <div className="navbar__left_style_airbnb">
                        <Link to="/">
                            <img src={isDarkMode ? logoClaro : logo} alt="logo" className="logo-img" />
                        </Link>
                    </div>
                    <ul className={`navbar__menu_style_airbnb`}>
                        <li><Link to="/coworking"><img src={isDarkMode ? coworkingN : coworkingB} className={`iconos-navbar5 ${scrolled ? 'scrolled' : ''}`} />Coworking</Link></li>
                        <li><Link to="/servicios"><img src={isDarkMode ? serviciosN : serviciosB} className={`iconos-navbar5 ${scrolled ? 'scrolled' : ''}`} />Servicios <span className="new-badge_airbnb">NOVEDAD</span></Link></li>
                        <li><Link to="https://edu-laofi-academy.odoo.com/home-academy" target="_blank"><img src={isDarkMode ? academiaN : academiaB} className={`iconos-navbar5 ${scrolled ? 'scrolled' : ''}`} />Academia <span className="new-badge_airbnb">NOVEDAD</span></Link></li>

                    </ul>

                    <div className="navbar__right_style_airbnb">
                        <label className="switch">
                            <input type="checkbox" onChange={toggleDarkMode} checked={isDarkMode} />
                            <span className="slider"><span className="thumb-icon">{isDarkMode ? '🌙' : '🌞'}</span></span>
                        </label>

                        <div className="modo-anfitrion">
                            {/* {!usuario ? <Link to="/login"><p className="modo-anfitrion">Conviértete en Anfitrión</p></Link> : <Link to="/#"><p className="modo-anfitrion">Modo Anfitrión</p></Link>} */}
                            {role === 'prov' ? <Link to="/crear-perfil-negocio"><p className="modo-anfitrion">Mis Servicios</p></Link> : null}
                            {role === 'user' ? (
                                <p className="modo-anfitrion" onClick={cambiarARolAnfitrion} style={{ cursor: 'pointer' }}>
                                    Ofrece tus Servicios
                                </p>
                            ) : null}
                        </div>

                        <div className="cuenta-icon">
                            {!usuario ? (
                                <Link to="/login"><p className="modo-anfitrion">Inicia sesión</p></Link>
                            ) : (
                                <div className="navbar__account-button" onClick={toggleUserMenu} ref={userMenuRef}>
                                    <img src={getAvatarSrc(avatarName)} alt="Avatar" className="navbar__avatar" /> Mi Cuenta
                                    {userMenuOpen && (
                                        <ul className="navbar__submenu1">
                                            <span className="navbar__username">{userName}</span><br />
                                            <small className="user-email">{usuario.email}</small>
                                            <li onClick={handleProfileClick}><FontAwesomeIcon icon={faUser} /> Perfil</li>
                                            {role === 'admin' && (
                                                <ul>
                                                    <li>
                                                        <Link to="/create-coin-package" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion" > <FontAwesomeIcon icon={faMoneyBill} /> Crear Paquete de Monedas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/verficarCoinsComprados" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} /> Verificar Compras</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/asignar-coins" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} />Gestión de Coins</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/space" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} /> Pon tu espacio</p>
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/users" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faUserGroup} /> Usuarios</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Busquedas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Busquedas</p>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            )}
                                            {role === 'user' && (
                                                <>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faWallet} /> Monedero</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/reservasRealizadas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Mis Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                        </Link>
                                                    </li>

                                                </>
                                            )}
                                            {
                                                role === 'prov' && (
                                                    <>
                                                        <li>
                                                            <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"> <FontAwesomeIcon icon={faWallet} /> Monedero</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"> <FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/space" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} /> Pon tu espacio</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/proveedor/misMarcas" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} /> Administra tu marca</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/users" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion">/<FontAwesomeIcon icon={faUserGroup} /> Clientes</p>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )
                                            }
                                            <li onClick={handleSignOut}><FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión</li>
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Mobile */}
            </div>
        </nav>
    );
}

export default Navbar;
